import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Breadcrumbs, Title, WrapperFlex } from '@unimed-fesp/components';
import FadeIn from '../../components/atoms/FadeIn';
import DadoBeneficiarios from '../../components/organisms/DadosBeneficiarios';
import history from '../../services/history';
import { Creators as BeneficiaryActions } from '../../store/ducks/beneficiario';
import theme from '../../styles/theme';
import { Container } from './styles';

const DetalheBeneficiariosNestle = ({ match }) => {
  const dispatch = useDispatch();
  const { codigoCartao } = match.params;
  const { loading, success, response } = useSelector(
    (state) => state.beneficiario.getBeneficiariesNestle
  );
  const filterParams = {
    query_type: 2,
    page: 0,
    count_per_page: 10,
    modality: 0,
    term: 0,
    beneficiary_wallet_number: codigoCartao.replace('0970', ''),
    beneficiary_name: '',
    beneficiary_birthday: null,
    beneficiary_document_number: null,
    only_dependents: false,
  };

  useEffect(() => {
    dispatch(
      BeneficiaryActions.postDataBeneficiariesNestleRequest(filterParams)
    );
  }, [codigoCartao]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="informações de beneficiário"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'Consulta de beneficiários',
                onNavigate: () => history.push('/novo/beneficiarios-nestle'),
              },
            ]}
          />
        </WrapperFlex>
        <DadoBeneficiarios
          loading={loading}
          success={success}
          data={response.data}
        />
      </FadeIn>
    </Container>
  );
};

export default DetalheBeneficiariosNestle;
